// extracted by mini-css-extract-plugin
export default {"item":"QuestionAnswerItem-module_item_pyLnKT"};